import { KYMW1400KomaPageComponent } from './kymw1400-koma-page.component';

/**
 * コマ割（共通ページ）の値を管理するクラス
 *
 * @export KYMW1400KomaPageModel
 * @class KYMW1400KomaPageModel
 */
export class KYMW1400KomaPageModel {

  kymw1400KomaPageComponent: KYMW1400KomaPageComponent = null;

  public srcLock = './assets/icons/KYMW14/disabledlock.png';                // ボタン画像（編集ロック）
  public srcKomaVisible = './assets/icons/KYMW14/komavisible.png';          // ボタン画像（コマ表示）

  public srcCancelEnabled = './assets/icons/KYMW14/cancel_enabled.png';     // キャンセルボタン（活性）
  public srcCancelDisabled = './assets/icons/KYMW14/cancel_disabled.png';   // キャンセルボタン（非活性）

  // コマタイプ
  public readonly KOMATYPE_MOVE: string = String('0');
  public readonly KOMATYPE_REPLACECURSOR: string = String('1');
  public readonly KOMATYPE_SHIFTCURSOR: string = String('2');

  /**
   * 選択バーカラー
   */
  public selectedBarStyle = String('');

  /**
   * ページ前後ボタン
   */
  public prevEnable = false;

  public nextEnable = false;

  /**
   * ページロックボタン
   */
  public pageLock = Boolean(true);

  public pageLockEnable = Boolean(true);

  public reloadEnable = Boolean(true);

  public seqNoEnable = Boolean(true);

  public cancelEnable = Boolean(false);

  /**
   * ページデータ
   */
  public pageData: any = null;

  /**
   * 計画値集計表
   */
  public planSummaryTable: Array<any> = new Array<any>();

  /**
   * フォントサイズリスト
   */
  public fontSizeList: Array<any> = new Array<any>();

  public templateName = String('');
  public komaType = String('0');
  public sliderValue = Number(160);
  public fontSize = Number(11);
  public allKomaVisible = Boolean(true);
  public otherPageFlag = Boolean(false);

  /**
   *Creates an instance of KYMW1400KomaPageModel.
   * @memberof KYMW1400KomaPageModel
   */
  constructor() {
    // フォントサイズリスト
    for (let i = Number(3); i < 49; i++) {
      this.fontSizeList.push(i);
    }
  }

  /**
   * 計画値集計表取得処理
   *
   * @memberof KYMW1400KomaPageModel
   */
  public initPlanSummaryTable(): void {
    this.planSummaryTable = [{ PlanNum: 0, SupplyAmount: 0, GPR: 0, SupplyPrice: 0 }];
  }

  /**
   * サーバからのページ情報をマネージャーに更新する
   *
   * @param {*} serverData
   * @memberof KYMW1400KomaPageModel
   */
  public updatePage(serverData: any): void {
    this.pageData = serverData.PageInfo;
    this.kymw1400KomaPageComponent.bindPage_CHANGEHandler(this.pageData);
  }

  /**
   * サーバからのページ情報をマネージャーに更新する
   *
   * @param {*} serverData
   * @memberof KYMW1400KomaPageModel
   */
  public updatePlanSummaryTable(serverData: any): void {
    this.planSummaryTable = [serverData];
  }

  /**
   * クリア処理
   *
   * @memberof KYMW1400KomaPageModel
   */
  public clear(): void {
    this.initPlanSummaryTable();
    this.pageData = null;
    this.kymw1400KomaPageComponent.bindPage_CHANGEHandler(this.pageData);
  }

  /**
   * コマタイプを初期値に変更
   *
   * @memberof KYMW1400KomaPageModel
   */
  public resetKomaType(): void {
    this.komaType = this.KOMATYPE_MOVE;
  }
}
